import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { useIntl } from 'react-intl';
import View from '@eeacms/volto-statistic-block/StatisticBlock/View';
import { default as editSchema } from '@eeacms/volto-statistic-block/StatisticBlock/schema';

import '@eeacms/volto-statistic-block/StatisticBlock/styles.less';

const Edit = (props) => {
  const {
    data: blockData = {},
    block = null,
    selected = false,
    onChangeBlock,
  } = props;
  const data = {
    ...blockData,
    animation: { ...blockData.animation, enabled: true, duration: 4 },
  };
  const intl = useIntl();
  const schema = editSchema({ data, intl });

  return (
    <>
      <View {...props} data={data} mode="edit" />

      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          formData={data}
          block={block}
          onChangeBlock={(id, value) =>
            onChangeBlock(id, {
              ...value,
              animation: { ...value.animation, enabled: true, duration: 4 },
            })
          }
        />
      </SidebarPortal>
    </>
  );
};

export default Edit;
